import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Loading from '../general/Loading';

const ExchangeModel = ({setResponse}) => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [showStatus, setShowStatus] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState('');
            const [loading, setLoading] = useState(false);


    // const exchanges = state?.exchanges || [];
const [exchanges, setExchanges] = useState(state?.exchanges || []);
    const order = state?.order || {};

    
// Helper function to format datetime string
const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    }).replace(',', '');
};

useEffect(() => {
  if (state?.exchanges) {
    const sortedExchanges = [...state.exchanges].sort((a, b) => {
      return new Date(b.req_on) - new Date(a.req_on); // descending
    });
    setExchanges(sortedExchanges);
  }
}, [state?.exchanges]);


const handleShowStatus = (req) => {
  setSelectedOrder({
    ...req,
    status: req.req_status || '',
    remark: req.remark || '',
  });
  setShowStatus(true);
};


    return (
        <>
        <div className="container my-4">
            <button className='close-btn' onClick={() => navigate('/manage-orders')}>Go Back</button>
            <p className='mt-4 fw-bold fs-5'>Refund/ Exchange Request for Order Id: {order.id} </p>

            {exchanges.length === 0 ? (
                <p>No exchange requests found for this order.</p>
            ) : (
                exchanges.map((req, idx) => {
                    // Parse ex_items safely
                    let exItems = [], bankDetailObj = {};
                    try {
                        if (req.ex_items && typeof req.ex_items === 'string' && req.ex_items.trim() !== '') {
                            exItems = JSON.parse(req.ex_items);
                        }
                    } catch (error) {
                        console.error('Error parsing ex_items JSON:', error);
                    }

try {
  if (req.bank_detail && typeof req.bank_detail === 'string' && req.bank_detail.trim() !== '') {
    bankDetailObj = JSON.parse(req.bank_detail);
  } else {
    bankDetailObj = req.bank_detail || {};
  }
} catch (error) {
  console.error('Error parsing bank_detail JSON:', error);
  bankDetailObj = {};
}


                    return (
                        <div key={idx} className="detail-bill my-2">
                            <p className="text-capitalize fw-semibold fs-5">
                                Request Type: {req.req_type || 'N/A'}
                            </p>

                            <div className='d-md-flex justify-content-between'>

                                <div>                <p className="para-text fw-semibold text-muted">Request Id: {req.id}<br />Initiated On: {formatDateTime(req.req_on)}</p>
                                    
                                    <span
                                        className="order-span text-capitalize"
                                    >
                                        Status: {req.req_status}
                                    </span><button
                                        className="order-btn ms-2 mt-2"
                                        onClick={() => handleShowStatus(req)}>
                                        Update Status
                                    </button>

                                    {req.remark && req.remark.trim() !== '' && (
                                        <p className='para-text fw-semibold mt-2 text-danger text-capitalize'>
                                            Remark: {req.remark}
                                        </p>
                                    )}

                                    {exItems.length > 0 && (
                                        <>
                                            <p className='mt-3 mb-0 para-text fw-bold'>Items:</p>
                                            <ul className="list-unstyled mb-2">
                                                {exItems.map((item, i) => (
                                                    <li key={i} style={{ fontSize: '0.9rem' }}>
                                                        {item.name} | Qty {item.qty} x ₹{item.price} = ₹{item.total_price}
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    )}

                                    {req.attachment && req.attachment.trim() !== '' && (
                                        <>
                                            <p className='my-0 para-text fw-bold'>Attachments:</p>
                                            <div className="d-flex flex-wrap gap-2 mb-2">
                                                {req.attachment.split(',').map((img, i) => (
                                                    <div
                                                        key={i}
                                                        style={{
                                                            width: 80,
                                                            height: 80,
                                                            borderRadius: 5,
                                                            backgroundColor: '#eee',
                                                            backgroundImage: `url(https://api.siddhabhairabistore.com/uploads/${img.trim()})`,
                                                            backgroundSize: 'cover',
                                                            backgroundPosition: 'center',
                                                        }}
                                                        alt={`Attachment ${i + 1}`}
                                                    />
                                                ))}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div>                <p className='fw-semibold my-0'>Customer Details:</p>
                                    <p className='para-text text-muted'>Name: {req.user_name}<br />Mobile No: {req.mobile}<br />
                                        Email: {req.email}<br />Address: {req.address} {req.city} {req.state} {req.pincode}</p>

                                    {req.req_type == 'refund' ?
                                        <>
                                            <hr />
                                            <p className='fw-semibold my-0'>Refund Receiving On:</p>
                                            {bankDetailObj.bank_name != null ?
                                                <p className='para-text text-muted'>Bank Name: {bankDetailObj.bank_name}<br />IFSC Code: {bankDetailObj.ifsc_code}<br />
                                                    Account Holder: {bankDetailObj.holder_name}<br />Account No: {bankDetailObj.acc_no}</p>
                                                : <p className='para-text text-muted'>UPI Id: {bankDetailObj.upi}</p>}
                                        </> : ''}
                                </div>

                            </div>
                            {/* flex ends */}

{showStatus && selectedOrder && selectedOrder.id == req.id && (
  <div className="mt-2">
    {/* <p className="fw-bold">Update Order Status</p> */}
    
    <div className="mb-2">
      <label className="profile-label mb-2">Select Request Status</label>
      <select
        className="product-control"
        value={selectedOrder.status || ''}
        onChange={(e) =>
          setSelectedOrder({ ...selectedOrder, status: e.target.value })
        }
      >
        <option value="">-- Choose Status --</option>
        {selectedOrder.req_type == 'refund' ? 
        <>
                <option value="Refund Initiated">Refund Initiated</option>
        <option value="Refund Processed">Refund Processed</option>
        <option value="Refund Completed">Refund Completed</option>
        <option value="Cancelled">Cancelled</option>
        </>
        : <>
        <option value="Exchange Initiated">Exchange Initiated</option>
        <option value="Exchange Shipped">Exchange Shipped</option>
        <option value="Out for Delivery">Out for Delivery</option>
        <option value="Exchange Delivered">Exchange Delivered</option>
        <option value="Cancelled">Cancelled</option>
        </>}

      </select>
    </div>

    <div className="mb-2">
  <label className="profile-label mb-2">Remark</label>
  <input
    type="text"
    className="product-control"
    value={selectedOrder.remark || ''}
    onChange={(e) =>
      setSelectedOrder({ ...selectedOrder, remark: e.target.value })
    }
  />
</div>


    <button
      className="edit-btn mt-2"
      onClick={async () => {
        try {
          const response = await fetch(
  `https://api.siddhabhairabistore.com/exchange-update/${selectedOrder.id}`,
  {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      req_status: selectedOrder.status,
      remark: selectedOrder.remark || '',
    }),
  }
);


          if (response.ok) {
const updatedOrders = exchanges.map((order) =>
  order.id === selectedOrder.id
    ? {
        ...order,
        req_status: selectedOrder.status,
        remark: selectedOrder.remark,
      }
    : order
);

  setExchanges(updatedOrders);
                    setResponse({ message: 'Request Status updated successfully', status: 'success' });
            setShowStatus(false);
    setSelectedOrder('');
    setTimeout(() => setResponse(''), 2000);
          } else {
                    setResponse({ message: 'Something Went Wrong. Try Again Later', status: 'error' });
    setSelectedOrder('');
    setTimeout(() => setResponse(''), 2000);
          }
        } catch (err) {
          console.error('Status update error:', err);
        }
      }}
    >
      Update Status
    </button>
  </div>
)}
                        </div>
                    );
                })
            )}
        </div>

        {loading && <Loading setLoading={setLoading} />}
        
        </>
    );
};

export default ExchangeModel;
